export type BloqueMapa = {
  numero: number;
  plantas: number | null;
  ciclo?: 'PC' | 'RC' | 'RC2';
  path: string;
  nota?: string;
};

export type MapaLote = {
  lote: string;
  finca: string;
  apertura: string;
  cierre: string;
  totalPlantas: number;
  fuente: string;
  viewBox: string;
  bloques: BloqueMapa[];
};

// Reconstrucción esquemática del croquis de campo. Las plantas marcadas como
// null no eran inequívocas en el original y deben completarse desde emp_bloques.
export const MAPA_LOTE_1: MapaLote = {
  lote: '1',
  finca: 'Guayabito',
  apertura: '2026-02-05',
  cierre: '2026-02-20',
  totalPlantas: 290053,
  fuente: 'Croquis de campo del 05/02/2026',
  viewBox: '0 0 1200 820',
  bloques: [
    { numero: 1, plantas: 10328, ciclo: 'PC', path: 'M820 545 L895 545 L902 760 L825 760 Z' },
    { numero: 2, plantas: 10498, ciclo: 'PC', path: 'M730 535 L805 535 L810 760 L735 760 Z' },
    { numero: 3, plantas: 11900, ciclo: 'RC', path: 'M640 530 L715 530 L720 760 L646 760 Z' },
    { numero: 4, plantas: 12159, ciclo: 'RC', path: 'M552 525 L626 525 L632 760 L558 760 Z' },
    { numero: 5, plantas: 11451, ciclo: 'PC', path: 'M462 516 L535 516 L541 760 L468 760 Z' },
    { numero: 6, plantas: 10860, ciclo: 'PC', path: 'M370 506 C405 530 422 558 438 600 L454 760 L382 760 C376 676 356 606 332 566 Z' },
    { numero: 7, plantas: 6738, ciclo: 'RC', path: 'M292 530 L326 555 C350 590 365 655 371 760 L300 760 L286 642 L286 590 L305 620 Z' },
    { numero: 8, plantas: 10130, ciclo: 'RC', path: 'M205 500 C245 502 275 512 294 530 L273 575 L278 760 L206 760 Z' },
    { numero: 9, plantas: 12047, ciclo: 'RC', path: 'M118 492 L193 496 L194 760 L120 760 Z' },
    { numero: 10, plantas: 12177, ciclo: 'PC', path: 'M30 488 L105 490 L108 760 L34 760 Z' },
    { numero: 11, plantas: 15387, ciclo: 'PC', path: 'M-58 486 L18 487 L22 760 L-52 760 Z' },
    { numero: 12, plantas: 16542, ciclo: 'PC', path: 'M-145 484 L-70 485 L-64 760 L-138 760 Z' },
    { numero: 13, plantas: 19498, ciclo: 'RC', path: 'M910 270 L975 270 L990 465 L927 465 Z' },
    { numero: 14, plantas: 13095, ciclo: 'PC', path: 'M20 348 L278 348 C322 348 346 363 372 386 L502 386 L502 430 L352 430 C320 402 295 392 254 392 L20 392 Z' },
    { numero: 15, plantas: 7977, ciclo: 'PC', path: 'M20 438 L270 438 C302 438 325 450 346 472 L20 472 Z' },
    { numero: 16, plantas: 23271, ciclo: 'RC', path: 'M825 122 L892 122 L915 445 L850 445 Z' },
    { numero: 17, plantas: 20354, ciclo: 'RC', path: 'M735 110 L800 110 L824 355 L760 355 Z' },
    { numero: 18, plantas: 9294, ciclo: 'PC', path: 'M388 344 L625 344 L625 382 L388 382 Z' },
    { numero: 19, plantas: 14504, ciclo: 'PC', path: 'M645 102 L710 102 L734 330 L670 330 Z' },
    { numero: 20, plantas: 11336, ciclo: 'RC', path: 'M555 100 L620 100 L644 330 L580 330 Z' },
    { numero: 21, plantas: 8598, ciclo: 'PC', path: 'M465 105 L530 105 L554 330 L490 330 Z' },
    { numero: 22, plantas: 1874, ciclo: 'PC', path: 'M375 165 L430 115 L464 330 L400 330 Z' },
    { numero: 23, plantas: 8829, ciclo: 'RC', path: 'M470 28 L760 28 L770 78 L480 78 Z' },
    { numero: 24, plantas: 3445, ciclo: 'RC', path: 'M930 18 L990 18 L997 108 L938 108 Z' },
  ],
};

const verticales = (valores: number[], x0 = 90, y0 = 120, ancho = 75, alto = 570, paso = 95): BloqueMapa[] =>
  valores.map((plantas, i) => ({
    numero: i + 1, plantas, ciclo: 'RC',
    path: `M${x0 + i * paso} ${y0} L${x0 + i * paso + ancho} ${y0} L${x0 + i * paso + ancho + 8} ${y0 + alto} L${x0 + i * paso + 5} ${y0 + alto} Z`,
  }));

const horizontales = (valores: number[], x0 = 110, y0 = 90, ancho = 760, alto = 38, paso = 52): BloqueMapa[] =>
  valores.map((plantas, i) => ({
    numero: i + 1, plantas, ciclo: 'RC',
    path: `M${x0} ${y0 + i * paso} L${x0 + ancho - (i % 4) * 18} ${y0 + i * paso} L${x0 + ancho - (i % 4) * 18} ${y0 + i * paso + alto} L${x0} ${y0 + i * paso + alto} Z`,
  }));

export const MAPA_LOTE_3: MapaLote = {
  lote: '3', finca: 'Guayabito', apertura: '2025-12-09', cierre: '2025-12-23',
  totalPlantas: 207650, fuente: 'Croquis de campo del 09/12/2025', viewBox: '0 0 1200 820',
  bloques: [
    { numero: 1, plantas: 12303, ciclo: 'PC', path: 'M650 650 L970 650 L970 715 L650 700 Z' },
    { numero: 2, plantas: 22399, ciclo: 'RC', path: 'M650 570 L980 590 L970 640 L640 620 Z' },
    { numero: 3, plantas: 38103, ciclo: 'RC', path: 'M760 345 L845 345 L850 565 L765 565 Z' },
    { numero: 4, plantas: 24107, ciclo: 'PC', path: 'M635 345 L720 345 L710 560 L625 555 Z' },
    { numero: 5, plantas: 12888, ciclo: 'PC', path: 'M510 390 L580 360 L590 555 L520 555 Z' },
    { numero: 6, plantas: 21027, ciclo: 'PC', path: 'M330 350 C390 390 420 455 430 710 L350 710 C350 535 325 445 285 405 Z' },
    { numero: 7, plantas: 42538, ciclo: 'RC', path: 'M770 75 L850 70 L870 315 L790 315 Z' },
    { numero: 8, plantas: 27926, ciclo: 'RC', path: 'M620 80 C675 105 700 175 700 315 L625 315 C625 210 600 155 570 125 Z' },
    { numero: 9, plantas: 15916, ciclo: 'PC', path: 'M455 85 L530 85 L555 315 L480 315 Z' },
  ],
};

export const MAPA_LOTE_2: MapaLote = {
  lote: '2', finca: 'Guayabito', apertura: '2024-12-30', cierre: '2025-01-29',
  totalPlantas: 540576, fuente: 'Croquis de campo del 30/12/2024', viewBox: '0 0 1200 1550',
  bloques: horizontales([
    11466,13415,19766,10805,11274,12945,14538,16125,18534,19500,
    19444,19271,19916,22203,22912,21238,20495,19860,18135,12390,
    7538,2276,30975,32856,34137,14569,20120,18114,10426,25333,
  ], 80, 35, 980, 34, 48),
};

export const MAPA_LOTE_4: MapaLote = {
  lote: '4', finca: 'Guayabito', apertura: '2025-11-25', cierre: '2025-12-18',
  totalPlantas: 468728, fuente: 'Croquis de campo del 25/11/2025', viewBox: '0 0 1200 820',
  bloques: [
    { numero: 1, plantas: 51583, ciclo: 'RC', path: 'M505 520 L570 510 L580 750 L515 750 Z' },
    { numero: 2, plantas: 25775, ciclo: 'RC', path: 'M680 610 C735 630 755 680 760 750 L690 750 C690 690 675 660 650 645 Z' },
    { numero: 3, plantas: 20303, ciclo: 'RC', path: 'M600 585 C640 605 655 640 660 720 L600 705 Z' },
    { numero: 4, plantas: 2907, ciclo: 'RC', path: 'M610 610 C635 625 642 655 642 680 L615 665 Z' },
    { numero: 5, plantas: 38164, ciclo: 'PC', path: 'M760 190 L830 180 L770 455 L700 445 Z' },
    { numero: 6, plantas: 78586, ciclo: 'RC', path: 'M675 190 L740 185 L690 450 L625 445 Z' },
    { numero: 7, plantas: 75370, ciclo: 'PC', path: 'M590 195 L655 190 L615 445 L550 440 Z' },
    { numero: 8, plantas: 60209, ciclo: 'RC', path: 'M510 205 L570 195 L535 430 L475 420 Z' },
    { numero: 9, plantas: 26292, ciclo: 'PC', path: 'M430 235 L490 210 L460 395 L400 380 Z' },
    { numero: 10, plantas: 20359, ciclo: 'PC', path: 'M350 235 L415 220 L390 345 L330 330 Z' },
    { numero: 11, plantas: 20463, ciclo: 'PC', path: 'M260 175 L350 205 L320 260 L235 230 Z' },
    { numero: 12, plantas: 17220, ciclo: 'PC', path: 'M195 135 L285 170 L245 215 L165 180 Z' },
    { numero: 13, plantas: 9474, ciclo: 'PC', path: 'M320 105 L420 160 L385 205 L290 150 Z' },
    { numero: 14, plantas: 6283, ciclo: 'RC', path: 'M430 140 L475 160 L450 250 L410 235 Z' },
    { numero: 15, plantas: 15740, ciclo: 'PC', path: 'M455 65 C570 35 720 45 865 75 L850 125 C700 105 585 100 475 125 Z' },
  ],
};

export const MAPA_LOTE_5: MapaLote = {
  lote: '5', finca: 'Guayabito', apertura: '2025-11-10', cierre: '2025-11-27',
  totalPlantas: 404502, fuente: 'Croquis de campo del 10/11/2025', viewBox: '0 0 1200 820',
  bloques: [
    ...verticales([30965,60089,59980,58979,56351,52649], 85, 105, 67, 600, 91),
    { numero: 7, plantas: 18744, ciclo: 'PC', path: 'M650 520 C750 500 805 420 820 305 L880 320 C865 470 790 565 665 610 Z' },
    { numero: 8, plantas: 38276, ciclo: 'PC', path: 'M655 180 L725 180 L730 500 L660 520 Z' },
    { numero: 9, plantas: 16056, ciclo: 'PC', path: 'M750 180 L820 180 L810 410 L755 475 Z' },
    { numero: 10, plantas: 4914, ciclo: 'PC', path: 'M850 320 L900 315 L895 425 L850 450 Z' },
    { numero: 11, plantas: 3461, ciclo: 'RC', path: 'M845 245 L920 245 L920 285 L845 285 Z' },
    { numero: 12, plantas: 5245, ciclo: 'RC', path: 'M660 100 L850 100 L850 145 L660 145 Z' },
  ],
};

export const MAPA_LOTE_6: MapaLote = {
  lote: '6', finca: 'Guayabito', apertura: '2025-11-17', cierre: '2025-12-03',
  totalPlantas: 270903, fuente: 'Croquis de campo del 17/11/2025', viewBox: '0 0 1200 1220',
  bloques: horizontales([28744,27233,25949,12822,12346,10510,10668,10633,11408,12313,8404,24771,8732,7397,6741,6500,3928,16930,11255,9259,8566], 90, 55, 850, 35, 50),
};

export const MAPA_LOTE_7: MapaLote = {
  lote: '7', finca: 'Gemelos', apertura: '2024-07-31', cierre: '2024-08-14',
  totalPlantas: 126141, fuente: 'Croquis de campo del 31/07/2024', viewBox: '0 0 1200 820',
  bloques: [
    { numero: 1, plantas: 42200, ciclo: 'RC', path: 'M855 70 L950 70 L950 735 L855 735 Z' },
    { numero: 2, plantas: 28656, ciclo: 'RC', path: 'M665 280 L755 280 L755 735 L665 735 Z' },
    { numero: 3, plantas: 18765, ciclo: 'RC', path: 'M485 280 L575 280 L575 735 L485 735 Z' },
    { numero: 4, plantas: 11094, ciclo: 'PC', path: 'M285 370 L380 320 L380 610 L285 570 Z' },
    { numero: 5, plantas: 25426, ciclo: 'PC', path: 'M140 170 C215 130 310 140 760 145 L760 210 L300 205 C220 205 190 250 190 340 L190 600 C190 675 225 715 300 735 L265 785 C150 755 105 690 105 590 L105 325 C105 250 105 205 140 170 Z' },
  ],
};

export const MAPA_LOTE_8: MapaLote = {
  lote: '8', finca: 'Gemelos', apertura: '2024-08-15', cierre: '2024-08-30',
  totalPlantas: 366095, fuente: 'Croquis de campo del 15/08/2024', viewBox: '0 0 1200 820',
  bloques: [
    ...verticales([9963,17385,14488,28560,29478], 715, 430, 70, 310, 90),
    { numero: 6, plantas: 4626, ciclo: 'PC', path: 'M180 735 L560 735 L560 775 L180 775 Z' },
    ...verticales([47391,30794,24959], 250, 410, 80, 315, 115).map((b, i) => ({ ...b, numero: i + 7 })),
    { numero: 10, plantas: 32342, ciclo: 'RC', path: 'M850 100 L930 80 L930 380 L850 380 Z' },
    { numero: 11, plantas: 43785, ciclo: 'RC', path: 'M700 155 L780 145 L780 380 L700 380 Z' },
    { numero: 12, plantas: 23730, ciclo: 'PC', path: 'M550 165 L630 165 L630 385 L550 385 Z' },
    { numero: 13, plantas: 29940, ciclo: 'PC', path: 'M390 165 L470 165 L470 390 L390 390 Z' },
    { numero: 14, plantas: 1032, ciclo: 'PC', path: 'M230 230 C270 205 295 185 315 175 L315 345 C290 355 265 360 230 365 Z' },
    { numero: 15, plantas: 7406, ciclo: 'RC', path: 'M100 150 C170 190 190 245 200 380 L130 390 C125 285 105 235 75 215 Z' },
    { numero: 16, plantas: 20038, ciclo: 'RC', path: 'M75 35 C380 45 650 55 900 20 L920 70 C650 125 360 105 70 90 Z' },
  ],
};

export const MAPA_LOTE_10: MapaLote = {
  lote: '10', finca: 'Las Gemelas', apertura: '2025-10-09', cierre: '2025-10-21',
  totalPlantas: 254576, fuente: 'Croquis de campo del 09/10/2025', viewBox: '0 0 1200 820',
  bloques: [
    ...verticales([63588,65630,63315,44639,16984], 470, 150, 90, 560, 125),
  ],
};

export const MAPA_LOTE_11: MapaLote = {
  lote: '11', finca: 'Moncha Solón', apertura: '2024-06-19', cierre: '2024-07-20',
  totalPlantas: 209084, fuente: 'Croquis de campo del 19/06/2024', viewBox: '0 0 1200 900',
  bloques: horizontales([23133,4482,12634,10039,18563,12695,10618,13527,16674,15686,20665,16716,16404,17248], 120, 55, 850, 42, 58),
};

export const MAPA_LOTE_12: MapaLote = {
  lote: '12', finca: 'Solón', apertura: '2024-07-04', cierre: '2024-08-05',
  totalPlantas: 347380, fuente: 'Croquis de campo del 04/07/2024', viewBox: '0 0 1200 900',
  bloques: horizontales([13753,43246,18367,15350,44049,18136,37595,15846,32497,15481,28166,5184,12266,4825,15399,22293], 140, 50, 850, 40, 52),
};

export const MAPA_LOTE_13: MapaLote = {
  lote: '13', finca: 'La Casona', apertura: '2024-09-06', cierre: '2024-10-24',
  totalPlantas: 784704, fuente: 'Croquis de campo del 06/09/2024', viewBox: '0 0 1200 980',
  bloques: horizontales([9958,23184,20294,6112,9198,84402,86472,89804,90576,78307,15737,71257,66918,55805,25265,26291,12844], 100, 45, 920, 40, 52)
    .map(b => ([11,17].includes(b.numero) ? { ...b, nota: 'Cifra de baja legibilidad; comparar con el dato manual.' } : b)),
};

export const MAPA_LOTE_14: MapaLote = {
  lote: '14', finca: 'La Casona', apertura: '2025-08-19', cierre: '2025-09-09',
  totalPlantas: 425923, fuente: 'Croquis de campo del 19/08/2025', viewBox: '0 0 1200 900',
  bloques: [
    ...verticales([12046,19448,15943,36856,44959,54400,49203,49503,28899,23584,18519,16953,16572,9296], 115, 160, 56, 560, 68),
    { numero: 15, plantas: 7958, ciclo: 'PC', path: 'M900 65 L955 65 L955 145 L900 145 Z' },
    { numero: 16, plantas: 53810, ciclo: 'RC', path: 'M80 80 C300 30 520 115 820 70 L830 130 C540 175 300 105 85 145 Z' },
  ],
};

const mapaLineal = (lote: string, finca: string, apertura: string, cierre: string, totalPlantas: number, valores: number[], fuente: string): MapaLote => ({
  lote, finca, apertura, cierre, totalPlantas, fuente, viewBox: `0 0 1200 ${Math.max(820, 100 + valores.length * 55)}`,
  bloques: horizontales(valores, 100, 45, 930, 39, 52),
});

export const MAPA_LOTE_16 = mapaLineal('16', 'Solón', '2025-07-31', '2025-08-15', 241947,
  [28110,8768,13096,2264,10215,12968,2197,2792,18424,21408,19163,18096,16484,15117,12341,8608,0,7528,6259,4810,2240],
  'Croquis de campo del 31/07/2025');
MAPA_LOTE_16.bloques[16].nota = 'El bloque 17 aparece sin cantidad en el croquis.';

export const MAPA_LOTE_17 = mapaLineal('17', 'Solón', '2025-08-08', '2025-08-20', 229186,
  [4998,4377,23467,23371,23438,23517,23799,25283,17979,16785,15825,14537,13483],
  'Croquis de campo del 08/08/2025');

export const MAPA_LOTE_19 = mapaLineal('19', 'Solón', '2024-06-12', '2024-06-28', 119467,
  [11332,21057,37343,20878,4065,24792], 'Croquis de campo del 12/06/2024');

export const MAPA_LOTE_20 = mapaLineal('20', 'La Casona', '2025-09-29', '2025-10-09', 224082,
  [13265,27894,23512,7558,9026,3903,13360,23122,48238,43920,18754], 'Croquis de campo del 29/09/2025');

export const MAPA_LOTE_21 = mapaLineal('21', 'La Casona', '2025-09-18', '2025-09-30', 175280,
  [72599,55617,12803,26593,2648], 'Croquis de campo del 18/09/2025');

export const MAPA_LOTE_22 = mapaLineal('22', 'La Casona', '2025-09-03', '2025-09-24', 377245,
  [31766,65357,67701,60821,70440,2049,7833,23680,12110,8898], 'Croquis de campo del 03/09/2025');

export const MAPA_LOTE_23 = mapaLineal('23', 'Las Gemelas', '2025-10-16', '2025-10-31', 310176,
  [50047,51892,50898,59089,46743,26675,8926,4894,12178,12004], 'Croquis de campo del 16/10/2025');

export const MAPA_LOTE_26 = mapaLineal('26', 'Las Gemelas', '2024-12-13', '2024-12-24', 113571,
  [5476,64927,4885,33346,7917], 'Croquis de campo del 13/12/2024');

export const MAPA_LOTE_27 = mapaLineal('27', 'Semilla', '2023-06-20', '2023-07-10', 178856,
  [52972,57960,17451,74900,27791,74448,15621], 'Croquis de semilla del 20/06/2023');

export const MAPA_LOTE_28 = mapaLineal('28', 'La Casona', '2024-01-08', '2024-01-22', 268775,
  [59972,40040,42560,40544,17150,30156,30192,990,17490], 'Croquis de campo del 08/01/2024');

const MAPAS: Record<string, MapaLote> = {
  '1': MAPA_LOTE_1, '2': MAPA_LOTE_2, '3': MAPA_LOTE_3, '4': MAPA_LOTE_4, '5': MAPA_LOTE_5,
  '6': MAPA_LOTE_6, '7': MAPA_LOTE_7, '8': MAPA_LOTE_8, '10': MAPA_LOTE_10,
  '11': MAPA_LOTE_11, '12': MAPA_LOTE_12, '13': MAPA_LOTE_13, '14': MAPA_LOTE_14,
  '16': MAPA_LOTE_16, '17': MAPA_LOTE_17, '19': MAPA_LOTE_19, '20': MAPA_LOTE_20,
  '21': MAPA_LOTE_21, '22': MAPA_LOTE_22, '23': MAPA_LOTE_23, '26': MAPA_LOTE_26,
  '27': MAPA_LOTE_27, '28': MAPA_LOTE_28,
};

export function getMapaLote(numero?: string | null): MapaLote | null {
  if (!numero) return null;
  // En datos históricos el cero se digitó algunas veces como letra O ("O1").
  // Normalizamos ambos casos y quitamos ceros iniciales antes de buscar el mapa.
  const normalizado = numero
    .trim()
    .toUpperCase()
    .replace(/^O(?=\d)/, '0')
    .replace(/^0+(?=\d)/, '');
  return MAPAS[normalizado] ?? null;
}
